import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lib-success-message',
  templateUrl: './success-message.component.html',
  styleUrls: ['./success-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuccessMessageComponent {}
